export function isNullOrUndefined(value: any) {
    return value == null || value == undefined;
}